<template>
  <div>
    <button type="button" @click="onClick">
      <v-avatar v-if="image" class="img-container" size="72">
        <v-img contain :src="image" />
      </v-avatar>
      <v-avatar v-else-if="value" class="img-container" size="72">
        <v-img contain :src="value" />
      </v-avatar>
      <div
        v-else
        style="background: #f7f7f7"
        class="img-container justify-center align-center img-container--empty"
      >
        <div class="d-flex justify-center align-center flex-column">
          <!-- <div></div> -->
          <div class="mt-2">
            <v-img
              height="25px"
              width="28px"
              :src="defualt_group_profile"
            ></v-img>
          </div>
          <div class="mt-2">
            <p class="photo-text">Add Photos</p>
          </div>
        </div>
      </div>
      <input
        @input="onFileInput"
        hidden
        type="file"
        ref="input"
        accept="image/*"
      />
    </button>
    <ImageCropperModal
      v-model="cropperModal"
      :image="image"
      :circle="true"
      @onCrop="onCrop"
    />
  </div>
</template>
<script>
import ImageCropperModal from "./ImageCropperModal.vue";
export default {
  components: { ImageCropperModal },
  data() {
    return {
      image: this.value,
      cropperModal: false,
      defualt_group_profile: require("@/assets/images/group_profile_image.svg"),
    };
  },

  props: {
    value: {
      type: String,
      default: null,
    },

    readonly: {
      type: Boolean,
    },
  },
  watch: {
    value(value) {
      // console.log("value image input");
      if (!value) {
        this.image = "";
      }
    },
  },
  methods: {
    onClick() {
      if (this.readonly) return;
      this.$refs.input.click();
    },

    onFileInput(event) {
      if (!event) return;
      this.cropperModal = true;
      const reader = new FileReader();
      const file = event.target.files[0];
      reader.onload = (e) => {
        this.image = e.target.result;
        this.$emit("change", file);
      };
      reader.readAsDataURL(file);
    },
    onCrop(croppedImage) {
      this.image = croppedImage.toDataURL();
      croppedImage.toBlob((blob) => {
        const file = new File([blob], "image.jpg");
        this.$emit("change", file);
      });
    },
  },
};
</script>

<style scoped>
.photo-text {
  font-family: Avenir;
  font-size: 10.5px;
  font-weight: 350;
  line-height: 14.34px;
  text-align: center;
  color: #333333bd;
}
.img-container {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}

.img-container--empty {
  width: 72px;
  height: 72px;
  background: rgba(51, 51, 51, 0.11);
  border: 1px dashed rgba(51, 51, 51, 0.7);
  border-radius: 50%;
}
</style>
